import { IPageSmallHeader, IPageHeaderBlock } from '@features/cms/typescript';
import styles from '@features/cms/components/pages/PageHeaderBlock/PageHeaderSmallBlock/PageHeaderSmallBlock.styles';
import Heading from '@components/Heading/Heading';
import sanitizeHtml from '@utils/sanitizeHtml';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  data: IPageHeaderBlock<IPageSmallHeader>;
  defaultBackground: string;
  isFirst: boolean;
};

// when updating, also update PagesAccordion
const PageHeaderSmallBlock = ({
  data,
  defaultBackground,
  isFirst
}: PropsType) => {
  const {
    header,
    subHeader,
    image
  } = data.headerData;
  const subHeaderHtml = sanitizeHtml(subHeader);
  return <header id={data.code} sx={styles.smallBlockHeader(defaultBackground)} data-testid="page-header-small-block">
      <div sx={styles.smallBlockContent} data-testid="page-header-small-block-content">
        <div>
          <Heading h={isFirst ? 1 : 2} display={4} pb={24} mobile>
            {header}
          </Heading>
          <p dangerouslySetInnerHTML={subHeaderHtml} />
        </div>
        {image && <div sx={styles.smallBlockContent.imageContainer}>
            <ResponsiveImage image={typeof image === 'string' ? image : image.path} alt={typeof image !== 'string' ? image.metadata.alt || header : header} />
          </div>}
      </div>
    </header>;
};
export default PageHeaderSmallBlock;